import { render, staticRenderFns } from "./ExitForm.vue?vue&type=template&id=7868e863&"
import script from "./ExitForm.vue?vue&type=script&lang=js&"
export * from "./ExitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports